import { render, staticRenderFns } from "./SwisetSelect.vue?vue&type=template&id=2bc1efd8"
import script from "./SwisetSelect.vue?vue&type=script&lang=js"
export * from "./SwisetSelect.vue?vue&type=script&lang=js"
import style0 from "./SwisetSelect.vue?vue&type=style&index=0&id=2bc1efd8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports